var map = {
	"./BasicToken.json": 267,
	"./Campaign.json": 266,
	"./CampaignData.json": 265,
	"./CampaignFactory.json": 264,
	"./CampaignProxy.json": 263,
	"./CategoricalEvent.json": 262,
	"./CategoricalEventProxy.json": 261,
	"./CentralizedOracle.json": 260,
	"./CentralizedOracleData.json": 259,
	"./CentralizedOracleFactory.json": 258,
	"./CentralizedOracleProxy.json": 257,
	"./Contract.json": 256,
	"./DetailedERC20.json": 255,
	"./DifficultyOracle.json": 254,
	"./DifficultyOracleFactory.json": 253,
	"./ERC20.json": 252,
	"./ERC20Basic.json": 251,
	"./EtherToken.json": 250,
	"./Event.json": 249,
	"./EventData.json": 248,
	"./EventFactory.json": 247,
	"./Fixed192x64Math.json": 246,
	"./FutarchyOracle.json": 245,
	"./FutarchyOracleData.json": 244,
	"./FutarchyOracleFactory.json": 243,
	"./FutarchyOracleProxy.json": 242,
	"./HumanFriendlyToken.json": 241,
	"./LMSRMarketMaker.json": 240,
	"./MajorityOracle.json": 239,
	"./MajorityOracleData.json": 238,
	"./MajorityOracleFactory.json": 237,
	"./MajorityOracleProxy.json": 236,
	"./Market.json": 235,
	"./MarketData.json": 234,
	"./MarketMaker.json": 233,
	"./Math.json": 232,
	"./Migrations.json": 231,
	"./Oracle.json": 230,
	"./OutcomeToken.json": 229,
	"./OutcomeTokenProxy.json": 228,
	"./Proxied.json": 227,
	"./Proxy.json": 226,
	"./SafeMath.json": 225,
	"./ScalarEvent.json": 224,
	"./ScalarEventData.json": 223,
	"./ScalarEventProxy.json": 222,
	"./SignedMessageOracle.json": 221,
	"./SignedMessageOracleData.json": 220,
	"./SignedMessageOracleFactory.json": 219,
	"./SignedMessageOracleProxy.json": 218,
	"./StandardMarket.json": 217,
	"./StandardMarketData.json": 216,
	"./StandardMarketFactory.json": 215,
	"./StandardMarketProxy.json": 214,
	"./StandardMarketWithPriceLogger.json": 213,
	"./StandardMarketWithPriceLoggerData.json": 212,
	"./StandardMarketWithPriceLoggerFactory.json": 211,
	"./StandardMarketWithPriceLoggerProxy.json": 210,
	"./StandardToken.json": 209,
	"./Token.json": 208,
	"./UltimateOracle.json": 207,
	"./UltimateOracleData.json": 206,
	"./UltimateOracleFactory.json": 205,
	"./UltimateOracleProxy.json": 204,
	"./WETH9.json": 203
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	var module = __webpack_require__(id);
	return module;
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error('Cannot find module "' + req + '".');
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 268;